import React, { useState } from 'react';

interface CollapsibleFiltersProps {
  children: React.ReactNode;
  label?: string;
  defaultCollapsed?: boolean;
}

/**
 * Wraps filter bars and header tiles to make them collapsible.
 * When collapsed, shows a thin bar with a label to expand again.
 */
const CollapsibleFilters: React.FC<CollapsibleFiltersProps> = ({
  children,
  label = 'Filters',
  defaultCollapsed = false,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <>
      {collapsed && (
        <div
          className="collapse-bar visible"
          onClick={() => setCollapsed(false)}
          title="Show filters"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
          <span>{label}</span>
        </div>
      )}
      <div
        className={`collapsible-section ${collapsed ? 'collapsed' : ''}`}
        style={{ position: 'relative', maxHeight: collapsed ? 0 : '500px' }}
      >
        <button
          className={`collapse-toggle ${collapsed ? 'collapsed' : ''}`}
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Show filters' : 'Hide filters'}
          type="button"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="18 15 12 9 6 15"/>
          </svg>
        </button>
        {children}
      </div>
    </>
  );
};

export default CollapsibleFilters;
